import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export const Logo: React.FC<LogoProps> = ({ className = "", variant = 'dark' }) => {
  return (
    <Link to="/" className={`${className} flex items-center justify-start`} style={{ display: 'inline-block' }}>
      <span className={`text-lg md:text-2xl [font-family:'ItemsTextTrial-Light',Helvetica] font-light ${
        variant === 'light' ? 'text-white' : 'text-black'
      }`}>
        BES<span className="text-[#0048FF]">.</span>
      </span>
    </Link>
  );
};